<div class=" flex-grow-1 d-flex flex-column">
    <div *ngIf="currentTab == 'active'" class="flex-grow-1 d-flex flex-column">
        <div class="d-flex justify-content-between flex-wrap m-c">
            <div class=" search-cont ">
                <div class="s-in form-input ">
                    <mat-icon class="input-icon">search</mat-icon>
                    <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control"
                        [(ngModel)]="searchInput" (input)="onSearch($event)" (keyup.enter)="onGo()" />
                </div>
                <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
                <div class="s-item d-box " (click)="onFilterView()">
                    <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
                </div>
            </div>
            <div
                class="btn-container d-flex justify-content-between  flex-wrap onnoard-company-modal ms-1 align-items-baseline">
                <button mat-raised-button color="primary" class="primary-btn   no-sh-btn s-lbtn" type="submit"
                    (click)="onAddClockCard('')"><i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} Card</button>
            </div>
        </div>
        <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>

        <div class="heading-2 mt-3 new-h">
            <div class="s-bt cursor-pointer" (click)="onAddClockCard('')"> <i class="fas fa-plus text-white"></i>
                {{"COMMON.ADD" | translate}} {{"RECRUITER.TIMECLOCK.CARD"|translate}}</div>
        </div>
        <div class="mt-4 c-container d-flex flex-wrap gap-3">
            <div class="t-c-card" *ngFor="let item of cardArr">
                <div class="img-div">
                    <div class="card-img"></div>
                </div>
                <div class="dit-div p-3">
                    <div class="d-flex justify-content-between align-items-center head">
                        <div>
                            <div class="title">{{item.name}}</div>
                            <div class="text-grey">{{"MENUITEMS.TIMECLOCK.TEXT" | translate}}</div>
                        </div>
                        <i class="material-icons cursor-pointer more-ic" *ngIf="item.type==0"
                            [matMenuTriggerFor]="menu">more_vert</i>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item color="primary" (click)="onAddClockCard(item)">
                                <mat-icon class="kt-margin-r-0">create</mat-icon>
                                <span>{{"COMMON.EDIT" | translate}} {{"COMMON.TITLE" | translate}}</span>
                            </button>
                            <button mat-menu-item color="primary" matTooltip="" (click)="onAssign(item)">
                                <mat-icon class="kt-margin-r-0">people</mat-icon>
                                <span>{{"COMMON.ASSIGNEDLIST" | translate}} </span>
                            </button>
                            <button mat-menu-item color="warn" (click)="onDeleteItem(item)" type="button">
                                <mat-icon class="kt-margin-r-0">delete</mat-icon>
                                <span>{{'BUTTON.DELETE' | translate}}</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div class="d-flex align-items-center me-4 assign-txt pt-1">
                        <span>{{ "RECRUITER.TIMECLOCK.ASSIGNEDEMP"|translate}}:</span>
                        <i class="material-icons mat-icons">person</i>
                        <span class="total">{{item.ass }}</span>
                    </div>
                    <div class="d-flex  align-items-center me-4 assign-txt pt-1">
                        <span class="me-2">{{"RECRUITER.TIMECLOCK.ADDEDAT" | translate}}:</span>
                        <span class="total ">{{item.c_at |dates:'date_time'}}</span>
                    </div>
                    <div class="d-flex gap-3 justify-content-between mt-3">
                        <button mat-raised-button color="primary" (click)="onAccessClock(item)" class="new-btn w-100">
                            {{"RECRUITER.TIMECLOCK.ACCESSCLOCK" | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="mat-table__message" *ngIf="cardArr.length==0">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
        </div>
    </div>
</div>
<div *ngIf="currentTab == 'archive'" class="flex-grow-1 d-flex flex-column"></div>
<app-loading-spinner></app-loading-spinner>